<template lang="pug">
v-select.round-lg.border-input(v-model="selectedType" :items="isDate ? dateTypes : types" item-text="text" item-value="value" dense solo flat hide-details :menu-props="{ bottom: true, offsetY: true }" :disabled="disabled")
  template(v-slot:append)
    div
  template(v-slot:item="{item}")
    .text-xs(v-if="isDate") {{ item.text }}
    .text-xs.neutral500--text(v-else) {{ item.text }}
  template(v-slot:selection="{item}")
    .text-xs(v-if="isDate") {{ item.text }}
    .text-xs.neutral500--text(v-else) {{ item.text }}
</template>

<script>

export default {
  name: 'TypeFieldDropdown',
  props: {
    dataType: {
      type: String,
      default: null
    },
    dateFormat: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    types: [
      { text: 'Regular text', value: 'string' }, 
      { text: 'Number', value: 'number' },
      { text: 'Date (DD/MM/YYYY)', value: 'date' }
    ],
    dateTypes: [
      { text: 'Date (DD/MM/YYYY)', value: 'DD/MM/YYYY' },
      { text: 'Date (DD-MM-YYYY)', value: 'DD-MM-YYYY' },
      { text: 'Date (YYYY-MM-DD)', value: 'YYYY-MM-DD' },
      { text: 'Date (YYYY/MM/DD)', value: 'YYYY/MM/DD' },
      { text: 'Date (MM-DD-YYYY)', value: 'MM-DD-YYYY' },
      { text: 'Date (MM/DD/YYYY)', value: 'MM/DD/YYYY' }
    ]
  }),
  computed: {
    isDate () {
      return this.dataType === 'date'
    },
    selectedType: {
      get () {
        if (this.dataType) {
          if (this.dataType === 'date') {
            return 'DD/MM/YYYY'
          }
          return this.dataType
        }
        return 'string'
      },
      set( newValue) {
        let dataEmitted = 'dataType'
        if (this.dataType === 'date') {
          dataEmitted = 'dateFormat'
        }
        this.$emit(`update:${dataEmitted}`, newValue)
      }
    }
  }
}
</script>
